<template>
  <ChatbotAboutLayout
    title="Quantum Readiness Chatbot"
    what-it-is-subtitle="Assess your organisation's quantum readiness"
    :description-paragraphs="descriptionParagraphs"
    :features="features"
    audience-subtitle="For teams planning their quantum journey"
    :audience-items="audienceItems"
    :resources="resources"
    :video="video"
    cta-text="Ready to try it? Open the live chatbot →"
    cta-route-name="quantumReadinessChatbotTab"
  />
</template>

<script>
import ChatbotAboutLayout from "@/components/ChatbotAboutLayout.vue";

export default {
  components: {
    ChatbotAboutLayout,
  },
  setup() {
    const descriptionParagraphs = [
      "How prepared is your organisation for the quantum era? The Quantum Readiness Chatbot guides you through a structured conversation to assess where you stand today and where quantum technologies could matter for your organisation.",
      "Through adaptive, step-by-step questioning, the chatbot collects information about your industry context, use cases, organisational readiness, and strategic horizon. It then produces a readiness profile with prioritised next steps tailored to your answers. When you are ready to go further, continue with the Quantum Roadmap chatbot to turn that profile into a concrete, phased action plan.",
    ];

    const features = [
      {
        title: "Share your context",
        text: "Describe your industry, goals, and what draws your organisation to quantum technologies right now.",
      },
      {
        title: "Explore quantum readiness",
        text: "Reflect on problem–solution fit, organisational readiness, technology maturity, and your strategic planning horizon.",
      },
      {
        title: "Get actionable guidance",
        text: "Receive a structured readiness report with scored dimensions, an archetype narrative, and a prioritised list of recommended actions.",
      },
    ];

    const audienceItems = [
      {
        title: "Who it's for",
        text: "Innovation leads, R&D managers, and executives exploring whether and how quantum fits their organisation.",
      },
      {
        title: "Best use cases",
        text: "Kick-starting a quantum initiative, aligning leadership, or preparing for deeper strategic work — then follow up with the Roadmap chatbot to plan integration into your pipeline.",
      },
      {
        title: "Recurring usefulness",
        text: "Revisit as your organisation matures — update your profile when priorities, teams, or market conditions change, and refresh your Roadmap as your strategy evolves.",
      },
    ];

    const resources = [
      {
        label: "Quantum Roadmap",
        to: { name: "aboutQuantumRoadmap" },
        description:
          "After your readiness assessment, use the Roadmap chatbot to build a phased action plan for integrating quantum into your company strategy.",
      },
      {
        label: "Quantum Readiness Center",
        href: "https://quantumready.eu/",
        description: "Learn more about the European Quantum Readiness Center initiative.",
      },
    ];

    const video = {
      src: "/videos/qreadiness_subtitles.mp4",
      type: "video/mp4",
    };

    return {
      descriptionParagraphs,
      features,
      audienceItems,
      resources,
      video,
    };
  },
};
</script>
